const offerRoutes = ($routeProvider: ng.route.IRouteProvider) => {
  $routeProvider
    .when('/listing/:listingId/offer_settings', {
      template: '<bb-offer-settings />',
    })
    .when('/listing/:listingId/offer/new', {
      template: '<bb-offer-edit is-new=true />',
    })
    .when('/listing/:listingId/offer/:offerId', {
      template: '<bb-offer-edit is-new=false />',
    });
};

offerRoutes.$inject = ['$routeProvider'];

export default offerRoutes;
